export default "__VITE_ASSET__1RfsWNVC__"